export var hasKey=function(n,r){return r in n};